import React, { useEffect, useRef, useState } from 'react';
import IconButton from '../Icon/IconButton';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import ContentEditable from 'react-contenteditable';
import { Scrollbars } from 'react-custom-scrollbars';
import { api } from '../../Api/app';
import messageStore from '../../Store/MessageStore';
import { useGlobal } from '../../contexts/GlobalContext';

export default function MenuMessages({
    elements,
    selected,
    setSelected,
    Model,
    selectedUpdate,
    loadSelected,
}) {
    const emojis =
        '😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 🥰 😘 😗 😙 😚 😋 😛 😝 😜 🤪 🤨 🧐 🤓 😎 🤩 🥳 😏 😒 😞 😔 😟 😕 🙁 😣 😖 😫 😩 🥺 😢 😭 😤 😠 😡 🤬 🤯 😳 🥵 🥶 😱 😨 😰 😥 😓 🤗 🤔 🤭 🤫 🤥 😶 😐 😑 😬 🙄 😯 😦 😧 😮 😲 🥱 😴 🤤 😪 😵 🤐 🥴 🤢 🤮 🤧 😷 🤒 🤕 🤑 🤠 😈 👿 👹 👺 🤡 💩 👻 💀 ☠️ 👽 👾 🤖 🎃 😺 😸 😹 😻 😼 😽 🙀 😿 😾 👋 🤚 🖐 ✋ 🖖 👌 🤏 ✌️ 🤞 🤟 🤘 🤙 👈 👉 👆 🖕 👇 ☝️ 👍 👎 ✊ 👊 🤛 🤜 👏 🙌 👐 🤲 🤝 🙏 ✍️ 💅 🤳 💪 🦾 🦵 🦿 🦶 👣 👂 🦻 👃 👶 👧 🧒 👦 👩 🧑 👨 👩‍🦱 🧑‍🦱 👨‍🦱 👩‍🦰 🧑‍🦰 👨‍🦰 👱‍♀️ 👱 👱‍♂️ 👩‍🦳 🧑‍🦳 👨‍🦳 👩‍🦲 🧑‍🦲 👨‍🦲 🧔 👵 🧓 👴 👲 👳‍♀️ 👳 👳‍♂️ 🧕 👮‍♀️ 👮 👮‍♂️ 👷‍♀️ 👷 👷‍♂️ 💂‍♀️ 💂 💂‍♂️ 🕵️‍♀️ 🕵️ 🕵️‍♂️ 👩‍⚕️ 🧑‍⚕️ 👨‍⚕️ 👩‍🌾 🧑‍🌾 👨‍🌾 👩‍🍳 🧑‍🍳 👨‍🍳 👩‍🎓 🧑‍🎓 👨‍🎓 👩‍🎤 🧑‍🎤 👨‍🎤 👩‍🏫 🧑‍🏫 👨‍🏫 👩‍🏭 🧑‍🏭 👨‍🏭 👩‍💻 🧑‍💻 👨‍💻 👩‍💼 🧑‍💼 👨‍💼 👩‍🔧 🧑‍🔧 👨‍🔧 👩‍🔬 🧑‍🔬 👨‍🔬 👩‍🎨 🧑‍🎨 👨‍🎨 👩‍🚒 🧑‍🚒 👨‍🚒 👩‍✈️ 🧑‍✈️ 👨‍✈️ 👩‍🚀 🧑‍🚀 👨‍🚀 👩‍⚖️ 🧑‍⚖️ 👨‍⚖️ 👰‍♀️ 👰 👰‍♂️ 🤵‍♀️ 🤵 🤵‍♂️ 👸 🤴 🦸‍♀️ 🦸 🦸‍♂️ 🦹‍♀️ 🦹 🦹‍♂️ 🤶 🧑‍🎄 🎅 🧙‍♀️ 🧙 🧙‍♂️ 🧝‍♀️ 🧝 🧝‍♂️ 🧛‍♀️ 🧛 🧛‍♂️ 🧟‍♀️ 🧟 🧟‍♂️ 🧞‍♀️ 🧞 🧞‍♂️ 🧜‍♀️ 🧜 🧜‍♂️ 🧚‍♀️ 🧚 🧚‍♂️ 👼 🤰 🤱 👩‍🍼 🧑‍🍼 👨‍🍼 🙇‍♀️ 🙇 🙇‍♂️ 💁‍♀️ 💁 💁‍♂️ 🙅‍♀️ 🙅 🙅‍♂️ 🙆‍♀️ 🙆 🙆‍♂️ 🙋‍♀️ 🙋 🙋‍♂️ 🧏‍♀️ 🧏 🧏‍♂️ 🤦‍♀️ 🤦 🤦‍♂️ 🤷‍♀️ 🤷 🤷‍♂️ 🙎‍♀️ 🙎 🙎‍♂️ 🙍‍♀️ 🙍 🙍‍♂️ 💇‍♀️ 💇 💇‍♂️ 💆‍♀️ 💆 💆‍♂️ 🧖‍♀️ 🧖 🧖‍♂️ 💅 🤳 💃 🕺 👯‍♀️ 👯 👯‍♂️ 🕴 👩‍🦽 🧑‍🦽 👨‍🦽 👩‍🦼 🧑‍🦼 👨‍🦼 🚶‍♀️ 🚶 🚶‍♂️ 👩‍🦯 🧑‍🦯 👨‍🦯 🧎‍♀️ 🧎 🧎‍♂️ 🏃‍♀️ 🏃 🏃‍♂️ 🧍‍♀️ 🧍 🧍‍♂️ 👭 🧑‍🤝‍🧑 👬 👫 👩‍❤️‍👩 💑 👨‍❤️‍👨 👩‍❤️‍👨 👩‍❤️‍💋‍👩 💏 👨‍❤️‍💋‍👨 👩‍❤️‍💋‍👨 👪 👨‍👩‍👦 👨‍👩‍👧 👨‍👩‍👧‍👦 👨‍👩‍👦‍👦 👨‍👩‍👧‍👧 👨‍👨‍👦 👨‍👨‍👧 👨‍👨‍👧‍👦 👨‍👨‍👦‍👦 👨‍👨‍👧‍👧 👩‍👩‍👦 👩‍👩‍👧 👩‍👩‍👧‍👦 👩‍👩‍👦‍👦 👩‍👩‍👧‍👧 👨‍👦 👨‍👦‍👦 👨‍👧 👨‍👧‍👦 👨‍👧‍👧 👩‍👦 👩‍👦‍👦 👩‍👧 👩‍👧‍👦 👩‍👧‍👧 🗣 👤 👥';

    const { user } = useGlobal();

    const [message, setMessage] = useState('');

    const [messageReference, setMessageReference] = useState({});

    const refContentEditable = useRef();

    const [boxEmoji, setBoxEmoji] = useState(false);

    const [sending, setSending] = useState(false);

    const [filename, setFilename] = useState('');

    useEffect(() => {
        handleMessageEdit();
    }, [sending]);

    useEffect(() => {
        setMessageReference({});
        setBoxEmoji(false);
    }, [selectedUpdate]);

    function handleMessageUserRequired(e) {
        selected.params.messageUser.required = e;
        Model.onEditElement(selected);
        setSelected({ ...selected });
    }

    function handleMessageUserVariable(e) {
        selected.params.messageUser.variable = e;
        Model.onEditElement(selected);
        setSelected({ ...selected });
    }

    function handleNewMessage(message = '', type) {
        setSubmenuType(false);
        selected.params.messages.push({
            message: message,
            type: type,
        });
        Model.onEditElement(selected);
        setSelected({ ...selected });
    }

    function handleRemoveMessage(indice) {
        const newMessages = [];

        selected.params.messages.map((row, key) => {
            if (key !== indice) {
                newMessages.push(row);
            }
        });

        selected.params.messages = newMessages;
        Model.onEditElement(selected);
        setSelected({ ...selected });
    }

    function handleMessageEditing(indice) {
        selected.params.messages.map((row, key) => {
            if (key === indice) {
                setMessage(row.message);
                setMessageReference({
                    message: row.message,
                    type: row.type,
                    key: key,
                });

                if (row.type === 'text') {
                    setTimeout(() => {
                        refContentEditable.current.focus();
                    }, 100);
                }
            }
        });
    }

    function insertEmoji(val) {
        const step = refContentEditable.current;

        step.focus();

        var selection = window.getSelection();

        for (var i = 0; i < step; i += 1) {
            selection.modify('extend', 'backward', 'character');
        }

        document.execCommand('insertText', false, val);
    }

    function replaceEmoji(text) {
        text = text.replace(':D', '😁');
        text = text.replace(':(', '🙁');
        text = text.replace(':)', '😀');
        text = text.replace(';(', '😢');
        text = text.replace(';)', '😉');
        text = text.replace('<3', '❤️');
        return text;
    }

    function checkSubmit(e) {
        if (!e.shiftKey && e.key === 'Enter') {
            setSending(true);
        }
    }

    function handleMessageEdit() {
        if (sending === true) {
            const newMessages = [];

            selected.params.messages.map((row, key) => {
                if (key === messageReference.key) {
                    row.message = message;
                    row.filename = filename;
                }

                newMessages.push(row);
            });

            console.log(newMessages);

            selected.params.messages = newMessages;

            Model.onEditElement(selected);
            setSelected({ ...selected });

            setFilename('');
            setMessage('');
            setMessageReference({});
            setSending(false);
        }
    }

    const [loadUpload, setLoadUpload] = useState(false);

    async function handleUpload(e) {
        try {
            setLoadUpload(true);

            const nameFileName = e.target.files[0].name;

            var formData = new FormData();
            formData.append('file', e.target.files[0], e.target.files[0].name);

            console.log(formData);

            let response = await api.post('chatbots/upload', formData);

            if (response.data.error === true) throw response.data.message;

            setMessage(response.data.link);
            setFilename(nameFileName);

            setSending(true);

            setLoadUpload(false);
        } catch (err) {
            console.log(err);
            setLoadUpload(false);
            messageStore.addError('Erro ao fazer upload do arquivo.');
        }
    }

    const [submenuType, setSubmenuType] = useState(false);

    return (
        <div className="messages">
            {selected.typeDialog === 'start' && (
                <div className="tutorialTypeDialog">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        width="1em"
                        height="1em"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                    >
                        <g fill="none">
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="#626262"
                                strokeWidth="2"
                            />
                            <path
                                d="M11.5 7h.5"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                            />
                            <path
                                d="M10 11h2v5"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M10 16h4"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                        <rect
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                            fill="rgba(0, 0, 0, 0)"
                        />
                    </svg>
                    <div>
                        <h2>Início</h2>
                        <p>
                            A conversa do seu chatbot sempre inicia através da
                            Entrada do usuário. Crie novos blocos para adicionar
                            conteúdos e desenvolva uma conversa com seu cliente.
                        </p>
                    </div>
                </div>
            )}

            {selected.typeDialog === 'end' && (
                <div className="tutorialTypeDialog">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        width="1em"
                        height="1em"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                    >
                        <g fill="none">
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="#626262"
                                strokeWidth="2"
                            />
                            <path
                                d="M11.5 7h.5"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                            />
                            <path
                                d="M10 11h2v5"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M10 16h4"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                        <rect
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                            fill="rgba(0, 0, 0, 0)"
                        />
                    </svg>
                    <div>
                        <h2>Exceções</h2>
                        <p>
                            O bloco de exceções vai te ajudar a tratar condições
                            padrão do seu chatbot.
                        </p>
                    </div>
                </div>
            )}

            {selected.typeDialog === 'attendance' && (
                <div className="tutorialTypeDialog">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        width="1em"
                        height="1em"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                    >
                        <g fill="none">
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="#626262"
                                strokeWidth="2"
                            />
                            <path
                                d="M11.5 7h.5"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                            />
                            <path
                                d="M10 11h2v5"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M10 16h4"
                                stroke="#626262"
                                strokeWidth="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                        <rect
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                            fill="rgba(0, 0, 0, 0)"
                        />
                    </svg>
                    <div>
                        <h2>Atendimento humano</h2>
                        <p>
                            O bloco de atendimento humano, sempre levará a algum
                            operador e finalizará o fluxo do bot.
                        </p>
                    </div>
                </div>
            )}

            <section>
                <div className="messages-bot">
                    {loadUpload === false &&
                        selected.params.messages.map((row, key) => (
                            <div className="config-message">
                                <div className={`message bot`}>


                                    {row.type === 'text' && row.message}

                                    {row.type === 'image' && (
                                        <img src={row.message} />
                                    )}

                                    {row.type === 'buttons' &&
                                        row.message
                                            .split('|')
                                            .map((row, key) => (

                                                <>
                                                    { key === 0 && <p style={{margin: '5px 0 10px 8px', padding: 0}}>{row}</p>}
                                                    { key > 0 && 
                                                        <button
                                                            type="button"
                                                            className="messageButton"
                                                            key={key}
                                                        >
                                                            {row}
                                                        </button>
                                                    }

                                                </>

                                            ))}

                                    {loadSelected === false &&
                                        row.type === 'button' && (
                                            <img src={row.message} />
                                        )}

                                    {loadSelected === true &&
                                        row.type === 'audio' && (
                                            <audio controls="controls">
                                                <source
                                                    src={''}
                                                    type="audio/mp3"
                                                />
                                                seu navegador não suporta HTML5
                                            </audio>
                                        )}

                                    {loadSelected === false &&
                                        row.type === 'audio' && (
                                            <audio controls="controls">
                                                <source
                                                    src={row.message}
                                                    type="audio/mp3"
                                                />
                                                seu navegador não suporta HTML5
                                            </audio>
                                        )}

                                    {loadSelected === false &&
                                        row.type === 'video' && (
                                            <video controls="controls">
                                                <source
                                                    src={row.message}
                                                    type="video/mp4"
                                                />
                                                seu navegador não suporta HTML5
                                            </video>
                                        )}

                                    {loadSelected === true &&
                                        row.type === 'video' && (
                                            <video controls="controls">
                                                <source
                                                    src={''}
                                                    type="video/mp4"
                                                />
                                                seu navegador não suporta HTML5
                                            </video>
                                        )}
                                </div>

                                <div className="buttons">
                                    <button
                                        type="button"
                                        className="removeMessage button-circle"
                                        onClick={() => handleRemoveMessage(key)}
                                    >
                                        <IconButton icon="del" />
                                    </button>

                                    <button
                                        type="button"
                                        className="editMessage button-circle"
                                        onClick={() =>
                                            handleMessageEditing(key)
                                        }
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                            width="1em"
                                            height="1em"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                d="M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6s-3.589 6-8 6z"
                                                fill="#626262"
                                            />
                                            <path
                                                d="M8.503 11.589v1.398h1.398l3.87-3.864l-1.399-1.398z"
                                                fill="#626262"
                                            />
                                            <path
                                                d="M14.43 8.464l-1.398-1.398l1.067-1.067l1.398 1.398z"
                                                fill="#626262"
                                            />
                                            <rect
                                                x="0"
                                                y="0"
                                                width="24"
                                                height="24"
                                                fill="rgba(0, 0, 0, 0)"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        ))}

                    {selected.typeDialog !== 'start' &&
                        selected.typeDialog !== 'end' && (
                            <div className="contentnewMessageRelative">
                                <div
                                    className="contentNewMessage"
                                    onClick={() => setSubmenuType(!submenuType)}
                                >
                                    <span>Adicionar nova mensagem</span>
                                    <button
                                        type="button"
                                        className="newMessage button-circle"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                            width="1em"
                                            height="1em"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 1024 1024"
                                        >
                                            <path
                                                d="M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                                                fill="#626262"
                                            />
                                            <path
                                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                                                fill="#626262"
                                            />
                                            <rect
                                                x="0"
                                                y="0"
                                                width="1024"
                                                height="1024"
                                                fill="rgba(0, 0, 0, 0)"
                                            />
                                        </svg>
                                    </button>
                                </div>

                                <ul
                                    className={`submenu ${
                                        submenuType === true
                                            ? 'active'
                                            : 'inactive'
                                    }`}
                                >
                                    <li
                                        onClick={() =>
                                            handleNewMessage(
                                                'Nova mensagem, clique em editar.',
                                                'text'
                                            )
                                        }
                                    >
                                        <span>Texto</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                            width="1em"
                                            height="1em"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 1024 1024"
                                        >
                                            <path
                                                d="M464 512a48 48 0 1 0 96 0a48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0a48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0a48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8c-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142c23.6-55.2 35.6-113.9 35.9-174.5c.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8c69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9c44.6 18.7 84.6 45.6 119 80c34.3 34.3 61.3 74.4 80 119c19.4 46.2 29.1 95.2 28.9 145.8c-.6 99.6-39.7 192.9-110.1 262.7z"
                                                fill="#626262"
                                            />
                                            <rect
                                                x="0"
                                                y="0"
                                                width="1024"
                                                height="1024"
                                                fill="rgba(0, 0, 0, 0)"
                                            />
                                        </svg>
                                    </li>

                                    {user.account.brokers.filter(
                                        (obj) =>
                                            obj.tipo === 'Whatsapp' &&
                                            obj.oficial === true
                                    ).length > 0 && (
                                        <li
                                            onClick={() =>
                                                handleNewMessage(
                                                    'Selecione uma opção|Botão 1|Botão 2',
                                                    'buttons'
                                                )
                                            }
                                        >
                                            <span>Botão</span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                aria-hidden="true"
                                                focusable="false"
                                                width="1em"
                                                height="1em"
                                                preserveAspectRatio="xMidYMid meet"
                                                viewBox="0 0 1024 1024"
                                            >
                                                <path
                                                    d="M464 512a48 48 0 1 0 96 0a48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0a48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0a48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8c-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142c23.6-55.2 35.6-113.9 35.9-174.5c.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8c69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9c44.6 18.7 84.6 45.6 119 80c34.3 34.3 61.3 74.4 80 119c19.4 46.2 29.1 95.2 28.9 145.8c-.6 99.6-39.7 192.9-110.1 262.7z"
                                                    fill="#626262"
                                                />
                                                <rect
                                                    x="0"
                                                    y="0"
                                                    width="1024"
                                                    height="1024"
                                                    fill="rgba(0, 0, 0, 0)"
                                                />
                                            </svg>
                                        </li>
                                    )}

                                    <li
                                        onClick={() =>
                                            handleNewMessage(null, 'audio')
                                        }
                                    >
                                        <span>Aúdio</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                            width="1em"
                                            height="1em"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 24 24"
                                        >
                                            <g fill="none">
                                                <rect
                                                    x="8"
                                                    y="2"
                                                    width="8"
                                                    height="13"
                                                    rx="4"
                                                    stroke="#626262"
                                                    strokeWidth="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M18 16.292A7.98 7.98 0 0 1 12 19a7.98 7.98 0 0 1-6-2.708"
                                                    stroke="#626262"
                                                    strokeWidth="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M12 19v3"
                                                    stroke="#626262"
                                                    strokeWidth="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M10 22h4"
                                                    stroke="#626262"
                                                    strokeWidth="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </g>
                                            <rect
                                                x="0"
                                                y="0"
                                                width="24"
                                                height="24"
                                                fill="rgba(0, 0, 0, 0)"
                                            />
                                        </svg>
                                    </li>
                                    <li
                                        onClick={() =>
                                            handleNewMessage(
                                                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAADcCAIAAAAk4inNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoyOGMwZmM0Ny0wMzgzLTQxYzktYmU1My04ZWI0MWU2ZGZkZjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzBDN0Y2N0EwMTk4MTFFQjgxNEZGMDNBMEUxNjlFNDUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzBDN0Y2NzkwMTk4MTFFQjgxNEZGMDNBMEUxNjlFNDUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozMzNhMGFmOC0yZjlhLTQzYjgtODYyZi0yYjhjMmVmZTRlZTkiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpjZjhiZDMxNC0xNzI1LWY1NDUtOWY0Ni04NTU2ODJmOTNjYTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7uCPtCAAAPWklEQVR42uyd2Xbbxh2HBYAkAO77Lu6bKGrhIlkbnTTpOXmAPlofoE+Qu97kornpkqSpUzuO7ViWbFnWTq2UqIWL1KHk+KRJ7NgCSA6A33eYYznHIkHM7wNmAMz8mT//5a9DAABp6Mh/f/qshB0BwK35/IvvWOwFAKQDkQCASABAJAAgEgAAIgEAkQCASABAJAAARAIAIgEAkQBQNTrZ37HTuTy7aLZa5M/Lq6sr7GJADwzDcCyr13Mib+A4llKRDuuNx8sbm7VD6AOoN2oo4LHnk0G71USXSI+W1n98volTEFAEJKcbO4ebtaNcIjCaClEhEtmmbx8ur27uo3mA0nS6erK80Tg9nxpLknPUgC82PF5ah0VAuZD0Plpak/gmUkXaPzp58nwDjQEUDRmVkCQPUqRHz9bRDEAFSEyyJJFa7c72Xh1tAFQASTLJ82BEIqM0NABQDVLyLEmk82YLex+oBil5liRSp4O7RkA9SMmzJJGgEVATUvKMh1YBkAGIBABEAgAiAQCRAAAQCQCIBABEAgAiAQAgEgAQCQCIBABEAgBAJAB6jg674Jd7hGPNJsEoGPQ6jrzanct2u3PebB03zi+abewfAJHefl5mGJ/b5nfbvC6rxSS87Z9dNFu1/ePtvfr69kGzBakARPoJo6BPRf3RoJs3/P6u4A36sN9JXsV8dHPnaHFlc+/wBBkCmhaJdN1G06F42MN++Bqb5FdCPjt51fbrD56+OqyfIkkQSYtEgq7JXIS4JPF9PE7rpzOjy6vbD5+tdTqXyBNE0tC1hGI+Fg265HpDcj5LRX1kcPXV/aXjBtYn0+owW1PflgxyPprKyWjRG6xm8ZOZvNthRqQgksoReN3H0zmHzdSj99fruGo563fbkCqIpFpIyhfK2Xdc2pYFjmNnJ1POnrkKINKAuTORsFuMffgg4tJ8KS3yBmQLIqmNTMzvd9v7ORIj3jISK1cBiEQVpDtXyIT7/KFuhyUZ8SJeEEk9FEci7CBODqOpkMDjCSyIpAq8LqvXNZjLaHodl0sEkTCIpAZGEoEBfno87CHjJYQMIikbq1nwOK0D3ACOZeNhN0IGkZRNJOimYBtcCBlEUjZhn2PwZ0WTaDHxyBlEUiqiYDAbBRq2xOfCQ0MQSbHQ8/yoy2FBziCSUiF9Kmq2REDOIJJSMVMTXzNEgkjKRTDQ8lQBx7I6HYeoQSRFQlV2dRweYIVICv1iND18TU5KiBpEUiStdoeejWm2OogaRFIk7U6Hpo3BAkMQSZmcnDYp2ZLT8+bV1RWiBpEUKtI5tgRAJKkcHDWwJQAiSWX/qEHJyKS2f4ycQSSlQoYlO3v1gW8Gkbl2AJEgkpJZ3dwd+DZsbB9gTXCIpGw2do4GXsVoZb2GkEEkZXN5ebm4sjXQcdrJDgZIEEkFLK/uDPCk9GR5AwmDSGqg1e788GxtIB+9VTvarB0hYRBJJbxYq+0d9rt/1e50/vtkBfGCSOrh6mromwfLfe7gfff4ZeOsiXhBJFVxet769/fP+/bA29LL7dWNPWQLIqmQrd2je4/60dda2z548PQVgqU1NLTK+8p69/5seTTeuyl/rzb3v/3hOZ71hkjqd+mi2ZoeT+p7MBF9cWXre5yL0LXTCJu1o7999eigLucT2c1W+6v7z2ARzkja4uT04suvn6SjvnwqqOOknppebuwRhciJDmGCSJqDDGNIT4w4kIn5khGfjrvNmXlj5/Dx8vph/VQxjc1xJqPBoNeR79vuXBL5G2dNPFMLkaRCkvRwce3H55thvzMScLodlvcp/Hpyer66ub+6sUvObArou7OM320LeBxel8Uk/sZy/seN89r+8cbOwfZeHZdJINLtabU7L9Zq5EUO2G6n2WE1WYyCUSQHbo68yJG73emcX7RJ4Oonpzv7x2fnyrjTSr5AKupLRbzkh3f8M4tJIK/EsOe82Vpa2V5a3aFq3RiIpDxIgLZqR1vKf0COnFYTYW8hE/6gi5OCQU9+JR3zPXj6CjeUIZLW4Q36O+PxW1fOJb8+PZYIeZ3/+eE5VWsD0t6Fxi5QE2Yj/+lsXnr96ZDP/slMXhQM2KUQSXNYzcIf7owYZUo/GTh9PJ0ziXAJImnsXFQtZ+Utom4S+WolK/Do/0MkbUD6YCTxveiJmY3C3UqON8AliKSBqwvVcuY37xHJ1GMU50tpPUo8QSQVQ/JdLadJ1nv6KU6bea6Y4jikBSKpEZJscq6wW019+CyP0zozkWJZVEyDSCprOZYhZwl3H0umBzy26bEEw8AliKQWSJrvjKd8ku8XfShhv7OUj2H/QySVUCnEQz77QD46HnZP5CJoAoikeIoj0WjQNcANuJ7KFUJDQCQFU0iHkxHvwDcjnwxmYn40B0RSJNl4IJcIULIx49nheNiDRoFICiM57B3LhKnapFI+NhxwomkgkmKIBFyTI1HatophhqbGEgGPHQ0EkRRA0GufGovTef+GZZiZiaTXaYFIgGpIRmcmUzTfBuU4draYdtpMEAlQCknnfCnDUv8wgV7HLZQzNosIkQB1kFxWK1mlPCpq0Ouq5azZyEMkQBEkkXcrOWVNXhB4/d2pnDYnqEMkGjEK+o+mFDmdzigYPpqSeaIuRAK3O67rFH1cv55Um9HaRECIRN1Ig/ToSBYVProzVisZTU0EhEgUcX3tq+fTXfuD02aeL6W1MxEQItECOX7PFVMkf6r5Rl6ndXYyqZGJgBCJjmZgmZmJhMdpVdn3CngcU91JtRAJ9B5yzJ4qJEjmVPntIgFncSQGkUDPKeWj6n6GOjHsoe25dYikNjQyq4eqmVQQSfK3ZZibqkeUbI+m5plSMre3R6h8KVqOY30uq89lc9iMFpP4c4UaZxfHjbPd/ZOtvaOBlK/U4MoHxZFou915qcbiS6oVyWzkSXci7He+7fxjEnny8rvthaFwvXH2fLX2Yr3Wt4Kqml2Lp1JItDuX69sHEIl2DHodGdrGQu73v4NhNYmTIxHSif9+sR/F6q5Xh4trc0xI2uTORPKf9xa39+oYI9GLz239bKFAhu+3uA8o8N1iddfFUXp4fOmuVzqe0PJypWSkOldMux1miEQpZOC+UJL66DFR8dPZ0R7NUfM4Ld0VtDW/6u/1quUZu9UIkaijkAmPZ4dliahRMNyt5Bw2mZvZaTORIzFqOtxwXUcjazULEIki8slgLi7nbQrSuyMuueyyrUNA3qpayaLK0C92MnFJHdU11SBSj64jk9ATl2R55oC8ieKmu/aH3tUahEgfRizUw+vIpBt2ZzxZGo3d2gHyi+TXyZugR/c2zEahWs4ofVKtsls37HeWR3t+HTkR9nxWHUsMez5odg35x+RXur+IdX1/D6tZXCgru7qmgu8j+ft4HVkw6Ev5WD4ZWtnYfbW5d3R89s5YCJGgOxZ0C7wekrwnDqtpvpT++73Fvt0Th0hdPE7LbN+vIxMxcvEAeZ03W3sHJ/XG2dlZs93pdPcjx4miwWoSXQ6zYIA/t8HtsMxOJv/136XLyyuI1A8Gfh2ZqBLyOUJDDqRf5l6G2z49nvzmwfLVlcJcUt4YyWYR50sZXAFTK2Gfozwaw8WG3mI28gvdKzw6BE7FxELuyZEIROoVr+858AZETfWkIr5RRc0xUYxIvEF/t5IxiTxCphFGksFs3A+R5KT7XFYlYzGJiJemGMsMJ4Y9EEkeOI5dKKftFiOCpUGKI7FIwAWRJG8fy8wXUy67BZHSJgwzVBmLB712iCRlJzIzEymvy4Y8aRlFVNekWqSpggIORaAvHRN2rpShubomvSIV89FI0IUMgRt0HFutZKmtrkmpSIVMODnsRXrAz7meIUZpdU0aRbp5MBS5Ab+GN3RrGVI4EZA6kciJqKD2daKBFEQqq2vSJVIk4CJDI2QFvBuzUSAuUfXgMkUiBb32qbEEUgLeB6tZrFYyOo6DSP+H12WdmUxpfr038AFcV9dMcSwLkV7jspvmi2ksmwg+FI+THH8TNFSqHbxIdou4UM5ikR1wOwIeR6WQGHil2gHH12Liq1jwDUjjurpmVLsimcTuysCY7gqkkxj2jGeHtSiSwOvUscQmoIRMzD+SDGpLpJuVtc1GAc0PZGQ0FUpFfVoRiYyI5ktpqxnTXYH8TOYisZBb/SJxHDtXTDltZjQ56BHl0XjY51CzSCzbnajncVrR2KB3MMzQ9ETS77apUySGYabHEgEPpruC3seaYWYnySHbokKRSvlY2O9EG4M+DiLSspddHLBIE7lIPOxG64J+otdxC6U+Tarth0j5VCg9oIuSQOPwBt1CKdOHSbU9FykT8+cHd5sMgP5U1+ytSPHwgB/cAGCo+zAaX630trpmD0UaDjhL+RhaEdCA1SRWe1lds1ciBTzd6a6YYQTowW41LZR7VZ+uJ2/qdVpmJpKYqAdow2W3zBVTvZgIKL9ITptpdqB1KQF4Bz6X7c54SvaJgDLH3dad7oq6lIBqQj57pRCnVySzka9WsgY9JuoB2okGXfJOqpVNJFEw3J3KCZQt2wfA20hGvIV0mC6RrheSzRox3RUoilxCtsWx5RGpPBrDdFegRAqZcCLsoUUkvQ7X6IBSGQ44aREJAI0DkQCASABAJAAgEgAAIgEAkQCASABAJAAARAIAIgEAkQCASAAAiAQARAIAIgEAkQAA/RWp2brErgQKpdW+HLBIb9ZSbZydoz2AQjk5Pf9FnvstkkH/eiHIzdoh2gMolDfpfZPnfov0Zv2t2v7xYb2BJgGKg+SWpPfmZyk1lKSJJPIi//qz7/+4enWFdgFKgiSW5PbmZ4HXmUR+MCIRMnH/zQ+7Byf3n7xE2wAFQRJLcnvzczYuqa6kVJGSEa/9p2K3y692vr6/dNFsoYUA5ZCUkqySxN781WYRSZKlvKHUBe9Zhpktpr/8+smNP2vbB1u79WTEE/I57BYjy+I+FaCIy8vLw+PT9e2D5dVau9O5+Z+8QT9XTEss5yVD5QjSs/x4OvuPe4uNsyb5K9m+py+2yGvouj47Gg/QQ6vd+VV6DQvljJTRkWwiESwm8Y9zhYeLr16s7V797JrDr7cbAEpgGCYeco9lh2U53MtWy4hsTSkfy8YDL9d3t/aO6sfnb06dANCDTsdZzYLfZYuG3NJPRPKL9Kabl0+FyAsNBjQFLgYAAJEAgEgAQCQAAEQCACIBAJEAgEgAAIgEAEQCACIBAJEAABAJAIgEAEQCACIBAN6X7sS+z7/4DjsCACn8T4ABAAPAjlPNtpiAAAAAAElFTkSuQmCC',
                                                'image'
                                            )
                                        }
                                    >
                                        <span>Imagem</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                            width="1em"
                                            height="1em"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 24 24"
                                        >
                                            <g fill="none">
                                                <path
                                                    d="M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6z"
                                                    stroke="#626262"
                                                    strokeWidth="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <circle
                                                    cx="8.5"
                                                    cy="8.5"
                                                    r="2.5"
                                                    stroke="#626262"
                                                    strokeWidth="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M14.526 12.621L6 22h12.133A3.867 3.867 0 0 0 22 18.133V18c0-.466-.175-.645-.49-.99l-4.03-4.395a2 2 0 0 0-2.954.006z"
                                                    stroke="#626262"
                                                    strokeWidth="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </g>
                                            <rect
                                                x="0"
                                                y="0"
                                                width="24"
                                                height="24"
                                                fill="rgba(0, 0, 0, 0)"
                                            />
                                        </svg>
                                    </li>
                                    <li
                                        onClick={() =>
                                            handleNewMessage(null, 'video')
                                        }
                                    >
                                        <span>Vídeo</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                            focusable="false"
                                            width="1em"
                                            height="1em"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 16 16"
                                        >
                                            <g fill="#626262">
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175l3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
                                                />
                                            </g>
                                            <rect
                                                x="0"
                                                y="0"
                                                width="16"
                                                height="16"
                                                fill="rgba(0, 0, 0, 0)"
                                            />
                                        </svg>
                                    </li>
                                </ul>
                            </div>
                        )}
                </div>

                <div className="messages-user">
                    {selected.params.messageUser.required && (
                        <div className="config-message">
                            <div className={`message user`}>
                                Resposta do usuário
                            </div>

                            <div className="variable config-message-user">
                                <label
                                    onClick={() =>
                                        handleMessageUserVariable(
                                            selected.params.messageUser
                                                .variable === null
                                                ? ''
                                                : null
                                        )
                                    }
                                >
                                    <ToggleSwitch
                                        value={
                                            selected.params.messageUser
                                                .variable !== null
                                                ? 1
                                                : 0
                                        }
                                        setValue={() => {}}
                                    />
                                    <span>Salvar resposta em variavel</span>
                                </label>

                                {selected.params.messageUser.variable !==
                                    null && (
                                    <div className="form">
                                        <input
                                            value={
                                                selected.params.messageUser
                                                    .variable
                                            }
                                            onChange={(e) =>
                                                handleMessageUserVariable(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Nome da variavel"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {selected.typeDialog !== 'start' &&
                    selected.typeDialog !== 'end' &&
                    selected.typeDialog !== 'attendance' && (
                        <div
                            className="config-message-user"
                            onClick={() =>
                                handleMessageUserRequired(
                                    !selected.params.messageUser.required
                                )
                            }
                        >
                            <ToggleSwitch
                                value={
                                    selected.params.messageUser.required ===
                                    true
                                        ? 1
                                        : 0
                                }
                                setValue={(e) => {}}
                            />
                            <span className="text">
                                Aguardar resposta do usuario
                            </span>
                        </div>
                    )}
            </section>

            {messageReference.type && (
                <div className="editing-message">
                    <div className="emojis">
                        <div
                            className={`list ${boxEmoji ? 'active' : 'hidden'}`}
                        >
                            <Scrollbars
                                style={{ width: '100%', height: '100%' }}
                            >
                                {emojis.split(' ').map((row, key) => (
                                    <button
                                        type="button"
                                        onClick={() => insertEmoji(row)}
                                        key={key}
                                    >
                                        {row}
                                    </button>
                                ))}
                            </Scrollbars>
                        </div>
                    </div>

                    {messageReference.type === 'buttons' && (
                        <div className="visible message-info">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                                width="1em"
                                height="1em"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 16 16"
                            >
                                <g fill="#626262">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="M8.93 6.588l-2.29.287l-.082.38l.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319c.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246c-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0z" />
                                </g>
                                <rect
                                    x="0"
                                    y="0"
                                    width="16"
                                    height="16"
                                    fill="rgba(0, 0, 0, 0)"
                                />
                            </svg>
                            <span>Separe os botões usando pipe.</span>
                        </div>
                    )}

                    <div className="visible">
                        {(messageReference.type === 'video' ||
                            messageReference.type === 'image' ||
                            messageReference.type === 'audio') && (
                            <div className="upload">
                                <div className="infos">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        focusable="false"
                                        width="1em"
                                        height="1em"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 16 16"
                                    >
                                        <g fill="#626262">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M8.93 6.588l-2.29.287l-.082.38l.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319c.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246c-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0z" />
                                        </g>
                                        <rect
                                            x="0"
                                            y="0"
                                            width="16"
                                            height="16"
                                            fill="rgba(0, 0, 0, 0)"
                                        />
                                    </svg>

                                    {messageReference.type === 'audio' && (
                                        <p>Extensões aceitas: .mp3 ou .ogg</p>
                                    )}

                                    {messageReference.type === 'video' && (
                                        <p>Extensões aceitas: .mp4</p>
                                    )}

                                    {messageReference.type === 'image' && (
                                        <p>Extensões aceitas: .jpg ou .png</p>
                                    )}
                                </div>

                                <div className="input-bt">
                                    <div className="input">
                                        <input
                                            onChange={handleUpload}
                                            type="file"
                                            name="file"
                                        />
                                        {loadUpload === true && (
                                            <i className="fa fa-spin fa-spinner"></i>
                                        )}
                                    </div>
                                    <button
                                        className="removeMessage button-circle"
                                        onClick={() => setMessageReference({})}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            preserveAspectRatio="xMidYMid meet"
                                            viewBox="0 0 16 16"
                                        >
                                            <g fill="#626262">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M8 8.707l3.646 3.647l.708-.707L8.707 8l3.647-3.646l-.707-.708L8 7.293L4.354 3.646l-.707.708L7.293 8l-3.646 3.646l.707.708L8 8.707z"
                                                />
                                            </g>
                                            <rect
                                                x="0"
                                                y="0"
                                                width="16"
                                                height="16"
                                                fill="rgba(0, 0, 0, 0)"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        )}

                        {(messageReference.type === 'text' ||
                            messageReference.type === 'buttons') && (
                            <>

                            
                                <div className="emojis">
                                    <div
                                        className={`buttons ${
                                            boxEmoji ? 'active' : ''
                                        }`}
                                    >
                                        <button
                                            type="button"
                                            className="close"
                                            onClick={() => setBoxEmoji(false)}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M19.1 17.2l-5.3-5.3 5.3-5.3-1.8-1.8-5.3 5.4-5.3-5.3-1.8 1.7 5.3 5.3-5.3 5.3L6.7 19l5.3-5.3 5.3 5.3 1.8-1.8z"
                                                ></path>
                                            </svg>
                                        </button>

                                        <button
                                            type="button"
                                            className="open"
                                            onClick={() => setBoxEmoji(true)}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <div className="input">
                                    <ContentEditable
                                        id="input-send"
                                        innerRef={refContentEditable}
                                        html={message}
                                        disabled={false}
                                        onChange={(e) =>
                                            setMessage(
                                                replaceEmoji(
                                                    e.currentTarget.innerText
                                                )
                                            )
                                        }
                                        onKeyDown={checkSubmit}
                                    />

                                    {!message && (
                                        <span>Digite uma mensagem</span>
                                    )}
                                </div>

                                <button
                                    className="removeMessage button-circle"
                                    onClick={() => setMessageReference({})}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 16 16"
                                    >
                                        <g fill="#626262">
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M8 8.707l3.646 3.647l.708-.707L8.707 8l3.647-3.646l-.707-.708L8 7.293L4.354 3.646l-.707.708L7.293 8l-3.646 3.646l.707.708L8 8.707z"
                                            />
                                        </g>
                                        <rect
                                            x="0"
                                            y="0"
                                            width="16"
                                            height="16"
                                            fill="rgba(0, 0, 0, 0)"
                                        />
                                    </svg>
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
